import { atom } from 'recoil'
import Database from './types/Database'
import QueryResult from './types/QueryResult'

export const sessionState = atom<{
  user: {
    uid: string
    email: string | null
    displayName: string | null
  } | null
  isAuthenticating: boolean
}>({
  key: 'session',
  default: {
    isAuthenticating: true,
    user: null
  }
})

export const ideasState = atom<QueryResult<Database.Idea[]>>({
  key: 'ideas',
  default: {
    loading: true,
    data: []
  }
})
